module.exports = "https://r.nearpod.com/assets/media/image/quick-launch-tooltip-77faab849662fa615e7ac08a4ee66e0c.svg";